"use client";
import Link from "next/link";
import { ArrowRight, Handshake, Target } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { partnerInquiries as data } from "@/lib/data/contact";

const accent = "var(--color-amber)";

export function PartnerInquiries() {
  return (
    <Section id="partnership-inquiries" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-amber)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-10 grid lg:grid-cols-2 gap-5">
          <Reveal delay={100}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <div className="flex items-center gap-3">
                <span className="grid place-items-center h-10 w-10 rounded-lg" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                  <Handshake className="h-4 w-4" style={{ color: accent }} />
                </span>
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Partnership Categories</span>
              </div>
              <div className="mt-4 space-y-3">
                {data.categories.map((c, i) => (
                  <div key={i} className="text-sm">
                    <div className="font-semibold" style={{ color: accent }}>{c.name}</div>
                    <div className="text-[rgb(var(--fg-muted))] mt-0.5 leading-relaxed">{c.body}</div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <div className="flex items-center gap-3">
                <span className="grid place-items-center h-10 w-10 rounded-lg" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                  <Target className="h-4 w-4" style={{ color: accent }} />
                </span>
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Evaluation Criteria</span>
              </div>
              <div className="mt-4 space-y-3">
                {data.criteria.map((c, i) => (
                  <div key={i} className="text-sm">
                    <div className="font-semibold" style={{ color: accent }}>{c.step}. {c.title}</div>
                    <div className="text-[rgb(var(--fg-muted))] mt-0.5 leading-relaxed">{c.body}</div>
                  </div>
                ))}
                <div className="pt-2">
                  <span className="font-semibold text-sm">{data.process.title}</span>
                  <p className="mt-1 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{data.process.body}</p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
        <Reveal delay={400}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
